import ToastPlugin from 'vux/src/plugins/toast/index.js'

/*
对vux的消息提示进行封装
因为vux的有些组件不允许的单独使用，所以需要关联Vue
使用vue.use, 并且添加原型msg
toast-type: success, warn, cancel, text
*/

function init_msg(Vue) {
Vue.use(ToastPlugin)
const msg = new Object()
msg.toast = function (text, type='text', position='middle', width='10em', time=2000) {
/*
text: 提示消息内容
type: text-文本消息, success-成功消息, error-错误消息, warn-警告消息, cancel-严重错误消息
position: 位置: 可选值 default, top, middle, bottom
width: 宽度
time: 停留时间, 单位ms
*/


if (type === 'error') {
text = '<span style="font-size: 25px">&times</span> ' + text
type = 'text'
}
Vue.$vux.toast.show({
text: text,
type: type,
position: position,
width: width,
time: time
})
}


Vue.prototype.msg = msg


Vue.msg = msg

return msg
}

export default init_msg;




// WEBPACK FOOTER //
// ./src/utils/msg.js